// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__8lc3V","link":"SideBar_link__Fpfsu"};